<template>
  <router-link
      :to="path"
      :class="{
      [buttonClass]: buttonClass,
      'current-event': currentEvent,
    }"
      :title="$t(title)"
  >
    <credit-card v-if="isPaid" class="mr-2 event-button__card"/>
    {{ $t(title) }}
  </router-link>
</template>

<script>
import {EVENT_TYPE, STREAM_STATUS} from '@/const';
import {SELECT_PACKAGE, WATCH} from '@/pages';
import CreditCard from '@/assets/img/creditCard.vue';

export default {
  name: 'EventButton',
  components: {CreditCard},
  props: {
    event: Object,
  },
  computed: {
    path() {
      if (this.event.has_access) {
        return {
          name: WATCH.name,
          params: {id: this.event.id},
        };
      }
      return {
        name: SELECT_PACKAGE.name,
        params: {
          id: this.event.id,
        },
      };
    },
    /**
     * @return {boolean}
     */
    isPaid() {
      return (
        !this.event.has_access &&
        (this.event.type === EVENT_TYPE.paid ||
            this.event.type === EVENT_TYPE.ppv)
      );
    },
    title() {
      if (this.event.has_access) {
        return 'Watch';
      }
      if (!this.event.has_access && this.event.type === EVENT_TYPE.register) {
        return 'Get access';
      }
      return 'Buy event';
    },
    buttonClass() {
      if (this.event.has_access) {
        return 'watch-button';
      }
      if (!this.event.has_access && this.event.type === EVENT_TYPE.register) {
        return 'registration-button';
      }

      return 'buy-button';
    },
    currentEvent() {
      return this.event.stream_status === STREAM_STATUS.live;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-button__card {
  width: .8rem;
  height: .8rem;
}
.watch-button {
  background: var(--settings-watch-button-background);
  color: var(--settings-watch-button-text-color);

  &:hover {
    color: var(--settings-watch-button-text-color);
  }

  &.current-event {
    background-color: var(--settings-watch-current-event-button-background);
    color: var(--settings-watch-current-event-button-text-color);

    &:hover {
      color: var(--settings-watch-current-event-button-text-color);
    }
  }
}

.registration-button {
  background-color: var(--settings-register-watch-button-background);
  color: var(--settings-register-watch-button-text-color);

  &:hover {
    color: var(--settings-register-watch-button-text-color);
  }

  &.current-event {
    background-color: var(--settings-registration-current-event-button-background);
    color: var(--settings-registration-current-event-button-text-color);

    &:hover {
      color: var(--settings-registration-current-event-button-text-color);
    }
  }
}

.buy-button {
  background-color: var(--settings-buy-button-background);
  color: var(--settings-buy-button-text-color);
  display: flex;
  align-items: center;

  &:hover {
    color: var(--settings-buy-button-text-color);
  }

  &.current-event {
    background-color: var(--settings-buy-current-event-button-background);
    color: var(--settings-buy-current-event-button-text-color);

    &:hover {
      color: var(--settings-buy-current-event-button-text-color);
    }
  }
}
</style>
